/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ICodeDisplayScope extends ng.IScope {
        codeValue: string;
        codeName: string;
        titleFormat: string;
        displayFormat: string;
        title: string;
        display: string;
        processConfigId: string;
    }

    export class CodeDisplay implements IDirective {
        public controller = ['$scope', '$q', 'applicationCodeService', CodeDisplayController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/codeDisplay.html';
        public restrict: string = "E";

        public scope: any = {
            codeValue: '=',
            processConfigId: "=",
            codeName: '@',
            titleFormat: '@',
            displayFormat: '@'
        };

        public link(scope: ICodeDisplayScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: CodeDisplayController): void {
            controller.setTitleAndDisplay();
        }
    }

    export class CodeDisplayController implements IController {
        private $scope: ICodeDisplayScope;
        private $q: ng.IQService;
        private applicationCodeService: services.ApplicationCodeService;
        private codes: models.ApplicationCode[];

        constructor($scope: ICodeDisplayScope, $q: ng.IQService, applicationCodeService: services.ApplicationCodeService) {
            this.$scope = $scope;
            this.$q = $q;
            this.applicationCodeService = applicationCodeService;

            $scope.$watch("codeValue", () => {
                this.setTitleAndDisplay();
            });
        }

        private getEnumerations(codeGroup: string): angular.IPromise<models.ApplicationCode[]> {
            var d = this.$q.defer();

            if (this.codes !== undefined && this.codes.length > 0) {
                d.resolve(this.codes);
            } else {
                if (codeGroup.indexOf("-") !== -1) {
                    this.applicationCodeService.getProcessLevelApplicationCodesForExecution(codeGroup, this.$scope.processConfigId).then(
                        applicationCodes => {
                            this.codes = applicationCodes;
                            d.resolve(applicationCodes);
                        }
                    );
                } else {
                    this.applicationCodeService.getApplicationCodesForEnum(codeGroup).then(
                        applicationCodes => {
                            this.codes = applicationCodes;
                            d.resolve(applicationCodes);
                        }
                    );
                }

                
            }

            return d.promise;
        }

        public setTitleAndDisplay() {
            var scope = this.$scope;
            this.getEnumerations(scope.codeName)
                .then(applicationCodes => {
                    var stringValue = scope.codeValue !== undefined && scope.codeValue !== null ? scope.codeValue.toString() : "%-13-%";
                    var code = Enumerable.from(applicationCodes).singleOrDefault(i => i.uniqueIdentifier.toString() === stringValue);
                    if (!code) {
                        scope.title = "";
                        scope.display = "";
                    } else {
                        scope.title = scope.titleFormat ? code.createFormattedString(scope.titleFormat) : code.shortDescription;
                        scope.display = scope.displayFormat ? code.createFormattedString(scope.displayFormat) : code.shortDescription;
                    }
                });
        }
    }
}

warsApp.registerDirective('CodeDisplay', []);